module.exports = __webpack_public_path__ + "static/media/Android.eb309ae2.png";